import {
  GET_SOURCE_SETTINGS_NOTES,
  GET_SOURCE_SETTINGS_NOTES_SUCCESS,
  GET_SOURCE_SETTINGS_NOTES_ERROR,
  CREATE_SOURCE_SETTINGS_NOTES,
  CREATE_SOURCE_SETTINGS_NOTES_SUCCESS,
  CREATE_SOURCE_SETTINGS_NOTES_ERROR,
  UPDATE_SOURCE_SETTINGS_NOTES,
  UPDATE_SOURCE_SETTINGS_NOTES_SUCCESS,
  UPDATE_SOURCE_SETTINGS_NOTES_ERROR,
  DELETE_SOURCE_SETTINGS_NOTES,
  DELETE_SOURCE_SETTINGS_NOTES_SUCCESS,
  DELETE_SOURCE_SETTINGS_NOTES_ERROR,
  BULK_CREATE_SOURCE_SETTINGS_NOTES,
  BULK_CREATE_SOURCE_SETTINGS_NOTES_SUCCESS,
  BULK_CREATE_SOURCE_SETTINGS_NOTES_ERROR,
} from "./actionTypes";

/* GET SOURCE_SETTINGS NOTES */
export const getSourceSettingsNotes = (action) => ({
  type: GET_SOURCE_SETTINGS_NOTES,
  payload: action
});

export const getSourceSettingsNotesSuccess = (data) => ({
  type: GET_SOURCE_SETTINGS_NOTES_SUCCESS,
  payload: data,
});

export const getSourceSettingsNotesError = (error) => ({
  type: GET_SOURCE_SETTINGS_NOTES_ERROR,
  payload: error,
});

/* CREATE SOURCE_SETTINGS NOTES */
export const createSourceSettingsNotes = (newNotes) => ({
  type: CREATE_SOURCE_SETTINGS_NOTES,
  payload: newNotes,
});

export const createSourceSettingsNotesSuccess = (data) => ({
  type: CREATE_SOURCE_SETTINGS_NOTES_SUCCESS,
  payload: data,
});

export const createSourceSettingsNotesError = (error) => ({
  type: CREATE_SOURCE_SETTINGS_NOTES_ERROR,
  payload: error,
});

/* UPDATE SOURCE_SETTINGS NOTES */
export const updateSourceSettingsNotes = (notes) => ({
  type: UPDATE_SOURCE_SETTINGS_NOTES,
  payload: notes,
});

export const updateSourceSettingsNotesSuccess = (data) => ({
  type: UPDATE_SOURCE_SETTINGS_NOTES_SUCCESS,
  payload: data,
});

export const updateSourceSettingsNotesError = (error) => ({
  type: UPDATE_SOURCE_SETTINGS_NOTES_ERROR,
  payload: error,
});

/* DELETE SOURCE_SETTINGS NOTES */
export const deleteSourceSettingsNotes = (notesId) => ({
  type: DELETE_SOURCE_SETTINGS_NOTES,
  payload: notesId,
});

export const deleteSourceSettingsNotesSuccess = (data) => ({
  type: DELETE_SOURCE_SETTINGS_NOTES_SUCCESS,
  payload: data,
});

export const deleteSourceSettingsNotesError = (error) => ({
  type: DELETE_SOURCE_SETTINGS_NOTES_ERROR,
  payload: error,
});

/* BULK CREATE SOURCE_SETTINGS NOTES */
export const bulkCreateSourceSettingsNotes = (bulkData) => ({
  type: BULK_CREATE_SOURCE_SETTINGS_NOTES,
  payload: bulkData,
});

export const bulkCreateSourceSettingsNotesSuccess = (data) => ({
  type: BULK_CREATE_SOURCE_SETTINGS_NOTES_SUCCESS,
  payload: data,
});

export const bulkCreateSourceSettingsNotesError = (error) => ({
  type: BULK_CREATE_SOURCE_SETTINGS_NOTES_ERROR,
  payload: error,
});
